import { api } from '@/shared/api'
import {
    CreateInviteLinksGroupDtoForChannels,
    CreateInviteLinksGroupDtoForSites,
    UpdateInviteLinksGroupDto,
} from '@synapex/shared'
import {
    InviteLinksGroupChannelsType,
    InviteLinksGroupSitesType,
} from './invite-links-group.types'
import { SiteLinksGroupType } from '../site-links-group/site-links-group.types'

class InviteLinksGroupService {
    async createGroupForChannels(
        data: CreateInviteLinksGroupDtoForChannels
    ): Promise<InviteLinksGroupChannelsType> {
        return await api.post<InviteLinksGroupChannelsType>(
            `/analytics/groups/${data.channelId}`,
            data
        )
    }

    async createGroupForSites(
        data: CreateInviteLinksGroupDtoForSites
    ): Promise<InviteLinksGroupSitesType> {
        return await api.post<InviteLinksGroupSitesType>(
            `/analytics/site/groups/${data.siteId}`,
            data
        )
    }

    async getGroupsForChannels(
        channelId: number
    ): Promise<InviteLinksGroupChannelsType[]> {
        return await api.get<InviteLinksGroupChannelsType[]>(
            `/analytics/groups/${channelId}`
        )
    }

    async getGroupsForSites(siteId: number): Promise<SiteLinksGroupType[]> {
        return await api.get<SiteLinksGroupType[]>(
            `/analytics/site/groups/${siteId}`
        )
    }

    async updateGroupForChannels(
        id: number,
        data: UpdateInviteLinksGroupDto
    ): Promise<InviteLinksGroupChannelsType> {
        return await api.put<InviteLinksGroupChannelsType>(
            `/analytics/groups/${id}`,
            data
        )
    }

    async updateGroupForSites(
        id: number,
        data: UpdateInviteLinksGroupDto
    ): Promise<InviteLinksGroupSitesType> {
        return await api.put<InviteLinksGroupSitesType>(
            `/analytics/site/groups/${id}`,
            data
        )
    }

    async deleteGroupForChannels(id: number): Promise<number> {
        return await api.delete(`/analytics/groups/${id}`)
    }

    async deleteGroupForSites(id: number): Promise<number> {
        return await api.delete(`/analytics/site/groups/${id}`)
    }
}

export const inviteLinksGroupService = new InviteLinksGroupService()
